module.exports = function(deps){
    deps['mony-shell']={};deps['@emotion/sheet']=require('@emotion/sheet')
  }